import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon25: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M9.99995 16.0003C11.1045 16.0003 12 16.8953 12 18.0003C12 19.1053 11.1045 20.0003 9.99995 20.0003H2C0.89556 20.0003 0 19.1053 0 18.0003C0 16.8953 0.89556 16.0003 2 16.0003H9.99995ZM9.99995 17.0003H2C1.44774 17.0003 1 17.4473 1 18.0003C1 18.5523 1.44774 19.0003 2 19.0003H9.99995C10.5522 19.0003 11 18.5523 11 18.0003C11 17.4473 10.5522 17.0003 9.99995 17.0003ZM11.8394 0.46425L14.9114 3.53625C15.5317 4.15725 15.5317 5.16226 14.9114 5.78126C14.4158 6.27626 13.6736 6.37526 13.0795 6.07826L12.1916 6.96325L19.5634 14.3493C20.1502 14.9343 20.1502 15.8842 19.5639 16.4712L19.4419 16.5933C18.8556 17.1793 17.9071 17.1793 17.3208 16.5933L9.94855 9.20625L9.06305 10.0933C9.33955 10.6433 9.27485 11.3223 8.86895 11.8133L8.76595 11.9262C8.14665 12.5462 7.14206 12.5462 6.52274 11.9262L3.45122 8.85426C2.83047 8.23526 2.83047 7.23025 3.45038 6.61025C3.94518 6.11425 4.68747 6.01525 5.2824 6.31225L9.29815 2.29625C9.00065 1.70225 9.09975 0.96025 9.59565 0.46425C10.2158 -0.15475 11.2188 -0.15475 11.8394 0.46425ZM11.4852 7.67126L10.6556 8.50025L18.0279 15.8863C18.2236 16.0813 18.5392 16.0813 18.7348 15.8863L18.8568 15.7643C19.0525 15.5683 19.0525 15.2523 18.8564 15.0563L11.4852 7.67126ZM4.15791 7.31625C3.92824 7.54625 3.92824 7.91725 4.15796 8.14625L7.22991 11.2192C7.45864 11.4482 7.83006 11.4482 8.05875 11.2192C8.28845 10.9902 8.28845 10.6193 8.05875 10.3893L4.98722 7.31725C4.75752 7.08825 4.3861 7.08825 4.15791 7.31625ZM9.94855 3.06126L6.04655 6.96325L8.41255 9.32826L9.59525 8.14625L11.1322 6.61025L12.3146 5.42726L9.94855 3.06126ZM10.3024 1.17225C10.0736 1.40025 10.0736 1.77225 10.3024 2.00025L13.3753 5.07325C13.604 5.30225 13.9754 5.30225 14.2046 5.07325C14.4339 4.84425 14.4339 4.47326 14.2042 4.24426L11.1327 1.17225C10.9028 0.94325 10.5317 0.94325 10.3024 1.17225Z"
        fill="#32BBC3"
      />
    </Icon>
  )
}
